
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/present-perfect-explanation';
const mainimage = '/Images/presperf.webp';

const sections = [
  { label: "Exercises", description: "Do this exercise to practice your grammar.", type: "quiz", subtype: "presentperfect" },
];

const PresentPerfect = () => (
  <GrammarPageLayout
    level="B1"
    title="Present Perfect"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Present Perfect Exercises"
    seoDescription="Connect past actions to the present with the present perfect tense. B1 level exercises with explanations."
    relatedCategory="grammar-exercises"
    relatedLevel="B1"
  />
);

export default PresentPerfect;

